function showModal(
  content,
  option = {
    title: '提示',
  }
) {
  uni.showModal({
    content,
    ...option,
  });
}

function alert(
  content,
  option = {
    title: '提示',
  }
) {
  // 弹框的文案无内容 或者 长度超出50，则不弹出
  if (!content || content.toString().trim() === '' || content.toString().trim().length > 150) {
    return alert('系统繁忙,请您稍后再试');
  }
  uni.showModal({
    content,
    showCancel: false,
    ...option,
  });
}

function toast(title, option = {}) {
  uni.showToast({
    title,
    icon: 'none',
    ...option,
  });
}

function loading(title = '加载中', option) {
  uni.showLoading({
    title,
    mask: true,
    ...option,
  });
}

function hideLoading(option) {
  uni.hideLoading({ ...option });
}

const _export = {
  showModal,
  alert,
  toast,
  loading,
  hideLoading,
};

export default _export;
export { showModal, alert, toast, loading, hideLoading };
